import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SociedadesService } from './sociedades.service';
import { Sociedad } from '../../../core/modelos/sociedad';
import { ConfirmService } from '../../../core/components/confirm/confirm.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { TranslateService } from '../../../../../node_modules/@ngx-translate/core';

/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
    selector: 'fuse-sociedades-datatable',
    templateUrl: './sociedades.component.html',
    styleUrls: ['./sociedades.component.scss']
})
export class SociedadesComponent implements AfterViewInit {
    displayedColumns = ['id', 'nombre', 'acciones'];
    dataSource: MatTableDataSource<Sociedad>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // Sociedades del usuario conectado
    sociedades: any;

    constructor(
        private sociedadesService: SociedadesService,
        private confirmService: ConfirmService,
        private notificaciones: NotificacionesService,
        private translate: TranslateService
    ) {
        this.getSociedades();
    }

    getSociedades() {

        this.sociedadesService.getSociedadesDatosBasicos().subscribe(
            data => {
                if (data.success) {
                    this.sociedades = data.items;
                    // Assign the data to the data source for the table to render
                    this.dataSource = new MatTableDataSource(this.sociedades);

                    this.dataSource.paginator = this.paginator;

                    // Traduzco etiqueta si es español
                    if (this.translate.currentLang === 'es') {
                        this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
                    }

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SinSociedades);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    /**
     * Set the paginator and sort after the view init since this component will
     * be able to query its view for the initialized paginator and sort.
     */
    ngAfterViewInit() { }

    applyFilter(filterValue: string) {
        // Ojo, el filtro que viene por defecto no tiene en cuenta estado, tipologia, etc porque son objetos...
        /*
        * filterValue = filterValue.trim(); // Remove whitespace
        * filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        * this.dataSource.filter = filterValue;
        */

        // Añado este filtro que incorpora los campos que le digamos
        this.dataSource.data = this.sociedades;
    }

    borrarSociedad(id: number) {
        this.confirmService.confirm(
            this.notificaciones.mensajes.IdiomaActual.Sociedades.TituloBorrar,
            this.notificaciones.mensajes.IdiomaActual.Sociedades.MensajeBorrar).subscribe(
                result => {
                    if (result) {
                        this.sociedadesService.deleteSociedad(id).subscribe(
                            data => {
                                if (data.success) {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SociedadBorrado);
                                    this.getSociedades();
                                } else {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SociedadNOBorrado);
                                }
                            },
                            err => {
                                this.notificaciones.errorServidor(err.status);
                            }
                        );
                    }
                }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/sociedades/sociedades.component.ts